import { LinearProgress } from '@mui/material';
import React from 'react';
import { connect } from 'react-redux';

import { RootState } from 'app/store';

import { selectLoading } from './loader.slice';

interface LoaderProps {
    loading: boolean;
}

class Loader extends React.Component<LoaderProps> {
    public render() {
        if (this.props.loading) {
            return <LinearProgress color='secondary' style={{ position: 'fixed', zIndex: 9000, width: '100%' }} />;
        }

        return '';
    }
}

const mapStateToProps = (state: RootState): LoaderProps => ({
    loading: selectLoading(state),
});

const connectedComponent = connect(mapStateToProps)(Loader);

export { connectedComponent as Loader };
